import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { loadUsers } from '@actions/admin';
import { selectAssignableUsers, isLoadingUsers } from '@selectors/admin';
import { isSuperAdmin } from '@selectors/authentication';
import ChangeAnalyst from './ChangeAnalyst';

const mapStateToProps = (state) => ({
  users: selectAssignableUsers(state),
  isLoading: isLoadingUsers(state),
  isSuperAdmin: isSuperAdmin(state),
});

const mapDispatchToProps = {
  loadUsers,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  injectIntl,
)(ChangeAnalyst);



// WEBPACK FOOTER //
// ./components/organisms/ChangeAnalyst/index.js